import React from 'react'
import { makeStyles } from '@material-ui/core'

import type { AnimatedLogoProps } from './index'

export type SpinnerLogoProps = AnimatedLogoProps

const useStyles = makeStyles({
  root: {},
  outline: {
    animation: '$ps-outline 4000ms ease  infinite'
  },
  brush: {
    animation: '$ps-brush 4000ms ease infinite'
  },
  '@keyframes ps-outline': {
    '0%': {
      transform: 'rotate(0)'
    },
    '10%': {
      transform: 'rotate(90deg)'
    },
    '40%': {
      transform: 'rotate(180deg)'
    },
    '50%': {
      transform: 'rotate(270deg)'
    },
    '80%': {
      transform: 'rotate(360deg)'
    },
    '100%': {
      transform: 'rotate(360deg)'
    }
  },
  '@keyframes ps-brush': {
    '0%': {
      transform: 'rotate(0)'
    },
    '10%': {
      transform: 'rotate(-180deg)'
    },
    '40%': {
      transform: 'rotate(-360deg)'
    },
    '50%': {
      transform: 'rotate(-540deg)'
    },
    '80%': {
      transform: 'rotate(-1080deg)'
    },
    '100%': {
      transform: 'rotate(-1080deg)'
    }
  }
})

function SpinnerLogo({ scale = 1, ...props }) {
  const classes = useStyles(props)
  const baseWidth = 369 * scale
  const baseHeight = 432 * scale

  return (
    <>
      <div
        style={{
          position: 'relative',
          width: baseWidth * 1.5,
          height: baseHeight * 1.25
        }}
        {...props}
      >
        <svg
          className={classes.outline}
          viewBox="0 0 369 432"
          style={{
            transformOrigin: `${baseWidth / 2}px ${baseWidth / 2}px`,
            position: 'absolute',
            left: baseWidth / 4,
            top: baseWidth / 4,
            width: baseWidth,
            height: baseHeight
          }}
        >
          <g id="outline" fill="#0766ee">
            <path d="M184,0C82.38,0,0,80.59,0,180c0,164,184,252,184,252,0,0,184-88,184-252C368,80.59,285.62,0,184,0ZM184,344c-88.37,0-160-71.63-160-160S95.63,24,184,24s160,71.63,160,160-71.63,160-160,160Z"></path>
          </g>
        </svg>
        <svg
          className={classes.brush}
          viewBox="0 0 369 432"
          style={{
            position: 'absolute',
            transformOrigin: `${baseWidth / 2}px ${baseWidth / 2}px`,
            left: baseWidth / 4,
            top: baseWidth / 4,
            width: baseWidth,
            height: baseHeight
          }}
        >
          <g id="brush" fill="#0766ee">
            <path d="M240,267.32l-.06-86.31-111.94,28v89.85c0,2.33,2.24,4.01,4.48,3.36l16.52-4.82c21-21.88,21-46.38,21-46.38v42s62.04-15.51,62.04-15.51c4.68-1.17,7.96-5.37,7.95-10.19Z"></path>
            <path d="M240,135.52c0-1.94-1.56-3.51-3.5-3.51h-10.49c-14,0-28-4.88-28-24.5v-45.5c0-9.11-8.56-15.79-17.4-13.58h0c-6.23,1.56-10.61,7.16-10.61,13.58v45.5c0,17.17-7.54,35.28-28,45.5l-5.29,2.65c-5.34,2.67-8.71,8.12-8.71,14.09v21.77l111.94-28,.06-27.99Z"></path>
          </g>
        </svg>
      </div>
    </>
  )
}
export default SpinnerLogo
